export const buttonClass =
  'bg-neutral-light-7 border-neutral-light-0 font-bold enabled:hover:bg-neutral-light-3 enabled:active:bg-neutral-light-0 active:transition-none  text-neutral-dark-2'
